import { Component, ComponentInterface, h, Prop, VNode } from '@stencil/core';

import { UniTemplate } from '@uiwebkit/common';
import { uniWatermark } from '@uni/license';

@Component({
  tag: 'uni-label',
  styleUrl: '../styles/label.css',
})
export class UniLabelComponent implements ComponentInterface {

  @Prop({ reflect: true }) dataFor: string;

  render(): VNode {
    const props = { htmlFor: this.dataFor };
    const classes = { 'uni-label': true };

    return UniTemplate(
      <label {...props} class={classes}>
        <slot />
      </label>,
    );
  }

  componentDidLoad(): void {
    uniWatermark('pro');
  }
}
